import { endOfDay, endOfHour, endOfMonth, endOfQuarter, endOfWeek, endOfYear, startOfDay, startOfHour, startOfMonth, startOfQuarter, startOfWeek, startOfYear } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { REPORTING_TIMEZONE } from './sf_constants';

export const BROWSER_IANA_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const calcZonedDate = (date, tz, fn, options = null) => {
    const inputZoned = utcToZonedTime(date, tz);
    const fnZoned = (options) ? fn(inputZoned, options) : fn(inputZoned);
    return zonedTimeToUtc(fnZoned, tz);
}
export const getZonedStartOfHour = (date, timezone) => {
    return calcZonedDate(date, timezone, startOfHour);
}

export const getZonedStartOfDay = (date, timezone) => {
    return calcZonedDate(date, timezone, startOfDay);
}

export const getZonedStartOfWeek = (date, timezone, options = { weekStartsOn: 1 }) => {
    return calcZonedDate(date, timezone, startOfWeek, options);
}

export const getZonedStartOfMonth = (date, timezone) => {
    return calcZonedDate(date, timezone, startOfMonth);
}

export const getZonedStartOfQuarter = (date, timezone) => {
    return calcZonedDate(date, timezone, startOfQuarter);
}

export const getZonedStartOfYear = (date, timezone) => {
    return calcZonedDate(date, timezone, startOfYear);
}

export const getZonedEndOfHour = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfHour);
}

export const getZonedEndOfDay = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfDay);
}

export const getZonedEndOfWeek = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfWeek, { weekStartsOn: 1 });
}

export const getZonedEndOfMonth = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfMonth);
}

export const getZonedEndOfQuarter = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfQuarter);
}

export const getZonedEndOfYear = (date, timezone) => {
    return calcZonedDate(date, timezone, endOfYear);
}

export const convertDateBetweenTimezones = (date, fromTimezone, toTimezone) => {
    return zonedTimeToUtc(utcToZonedTime(date, fromTimezone), toTimezone)
}

// Hours of the day already finished in a timezone: at 14:30 there, hours 0 through
// 13 are complete, so 14 of them. Empty between midnight and 01:00, where nothing
// has finished yet. Mirrors DaySegmentHelper.completed_hour_list on the API, which
// is what answers Through This Hour when no list is sent.
export const getCompletedHoursInTimezone = (timezone = REPORTING_TIMEZONE, date = new Date()) => {
    const currentHour = utcToZonedTime(date, timezone).getHours();
    return Array.from({ length: currentHour }, (_, hour) => hour);
}

export const formatDatePST = (date) => {
    return date?.toLocaleDateString('en-CA', {
        timeZone: REPORTING_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
};